<!--
 * @Description:
 * @Author: rqcheng
 * @Date: 2022-06-09 12:45:36
 * @LastEditTime: 2024-05-03 18:27:41
 * @LastEditors: rqcheng
-->
<template>
  <div class="common-dialog">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="cocm"
      :width="width"
      v-bind="$attrs"
    >
      <slot></slot>
      <span slot="footer" class="dialog-footer">
        <slot name="btn">
          <el-button type="info" @click="dialogVisible = false" size="small"
            >取 消</el-button
          >
          <el-button type="success" @click="confirm" size="small"
            >确 定</el-button
          >
        </slot>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "CommonDialog",
  props: {
    width: {
      type: String,
      default: () => "30%"
    },
    title: {
      type: String,
      default: () => "提示"
    },
    cocm: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },
    hiden() {
      this.dialogVisible = false;
    },
    confirm() {
      this.$emit("confirm");
      this.hiden();
    }
  }
};
</script>
<style lang="less" scoped>
.common-dialog {
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/CommonDialog.vue